import { Box, Button, Card, Divider, Stack, Tooltip, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import moment from 'moment';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { capturePHEvents } from '../analytics/posthog.analytics';
import { PH_CLASS_JOIN_CLICK } from '../utils/posthog.eventNames';
import Label from '../fl-components/Label';
import Iconify from '../fl-components/Iconify';
import Image from '../fl-components/Image';
import JoinClassModal from './JoinClassModal';
import ClassDetailModal from './ClassDetailModal';

function IconComp({ name }) {
  return <Iconify icon={name} width={18} height={18} />;
}

IconComp.propTypes = {
  name: PropTypes.string
};

function CustomRow({ children }) {
  return (
    <Stack direction="row" spacing={1} alignItems="center">
      {children}
    </Stack>
  );
}

CustomRow.propTypes = {
  children: PropTypes.node
};

function SubText({ children }) {
  return <Typography fontSize={14}>{children}</Typography>;
}

SubText.propTypes = {
  children: PropTypes.node
};

export default function DiscoverClassCard({ classData }) {
  const currentUser = useSelector((state) => state.auth.currentUser);
  const [openModal, setOpenModal] = useState(false);
  const [openClassModal, setOpenClassModal] = useState(false);

  return (
    <>
      <Card onClick={() => setOpenClassModal(true)} sx={{ cursor: 'pointer' }}>
        <Image
          src={classData.bannerUrl}
          sx={{
            width: '100%',
            height: '190px'
          }}
          imageStyle={{
            width: '100%',
            height: 'auto'
          }}
        />
        <Box p={2}>
          <Label sx={{ mb: 2 }}>{classData.category}</Label>

          <Tooltip title={classData.name} placement="bottom-start">
            <Typography sx={{ mb: 2 }} fontSize={18} noWrap>
              {classData.name}
            </Typography>
          </Tooltip>

          <Stack direction="column" spacing={1}>
            <CustomRow>
              <IconComp name="uil:calender" />
              <SubText>Started on {moment(classData.createdAt).format('DD MMM YYYY')}</SubText>
            </CustomRow>
            <CustomRow>
              <IconComp name="clarity:book-line" />
              <SubText>{classData.subject}</SubText>
            </CustomRow>
            {/* <CustomRow>
              <IconComp name="bx:user" />
              <SubText>John Doe</SubText>
            </CustomRow> */}
          </Stack>
        </Box>
        <Divider />
        <Box
          textAlign="center"
          py={1}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
          sx={{ cursor: 'default' }}
        >
          <Button
            onClick={() => {
              capturePHEvents(PH_CLASS_JOIN_CLICK, { classData });
              setOpenModal(true);
            }}
          >
            Join
          </Button>
        </Box>
      </Card>

      <JoinClassModal
        isOpen={openModal}
        handleClosePopup={() => {
          setOpenModal(false);
        }}
        classData={classData}
        currentUser={currentUser}
      />

      <ClassDetailModal
        isOpen={openClassModal}
        handleClose={() => setOpenClassModal(false)}
        classDetails={classData}
      />
    </>
  );
}

DiscoverClassCard.propTypes = {
  classData: PropTypes.object
};
